import { Component, ElementRef, Input, OnChanges, OnInit, Optional, Self, SimpleChanges, ViewChild } from '@angular/core'
import { Timezone } from '@shared/models/timezone.model'
import { ControlValueAccessor, FormControl, NgControl } from '@angular/forms'
import { MatSelect } from '@angular/material/select'
import { MatOption } from '@angular/material/core'
import { MatFormFieldControl } from '@angular/material/form-field'

@Component({
  selector: 'lin-form-timezone-select',
  templateUrl: './timezone-select.component.html',
  providers: [{ provide: MatFormFieldControl, useExisting: TimezoneSelectComponent }],
  standalone: false,
})
export class TimezoneSelectComponent implements ControlValueAccessor, OnInit, OnChanges, MatFormFieldControl<Timezone['id']> {
  // prettier-ignore-start
  get value() {
    // eslint-disable-next-line @typescript-eslint/no-unsafe-return
    return this.matSelect.value
  }
  set value(value) {
    // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment
    this.matSelect.value = value
  }

  get controlType() {
    return this.matSelect.controlType
  }
  get disabled() {
    return this.matSelect.disabled
  }
  get empty() {
    return this.matSelect.empty
  }
  get errorState() {
    return this.matSelect.errorState
  }
  get focused() {
    return this.matSelect.focused
  }
  get id() {
    return this.matSelect.id
  }
  get placeholder() {
    return this.matSelect.placeholder
  }
  get required() {
    return this.matSelect.required
  }
  get shouldLabelFloat() {
    return this.matSelect.shouldLabelFloat
  }
  get stateChanges() {
    return this.matSelect.stateChanges
  }
  // prettier-ignore-end

  @Input() timezones: Timezone[]

  @ViewChild(MatSelect, { static: true }) matSelect: MatSelect
  @ViewChild(MatOption, { read: ElementRef }) matOptionElement: ElementRef

  filteredTimezones: Timezone[]

  readonly timezoneFilter = new FormControl()

  constructor(@Optional() @Self() public ngControl: NgControl) {
    if (ngControl) {
      this.ngControl.valueAccessor = this
    }
  }

  ngOnInit() {
    this.filteredTimezones = this.timezones
    this.matSelect.ngControl = this.ngControl
  }

  ngOnChanges({ timezones }: SimpleChanges) {
    if (timezones && !timezones.previousValue && timezones.currentValue) {
      this.filteredTimezones = <Timezone[]>timezones.currentValue
    }
  }

  filterTimezones(term: string) {
    if (!term) {
      this.filteredTimezones = this.timezones
      return
    }

    term = term.toLowerCase()

    const isMatchingTerm = ({ displayName }: Timezone) => displayName.toLowerCase().indexOf(term) >= 0
    this.filteredTimezones = this.timezones.filter(isMatchingTerm)
  }

  // prettier-ignore-start
  writeValue(v: any): void {
    this.matSelect.writeValue(v)
  }
  registerOnChange(fn: any): void {
    // eslint-disable-next-line @typescript-eslint/no-unsafe-argument
    this.matSelect.registerOnChange(fn)
  }
  registerOnTouched(fn: any): void {
    // eslint-disable-next-line @typescript-eslint/no-unsafe-argument
    this.matSelect.registerOnTouched(fn)
  }
  setDisabledState(isDisabled: boolean): void {
    this.matSelect.setDisabledState(isDisabled)
  }
  onContainerClick(event: MouseEvent): void {
    this.matSelect.onContainerClick()
  }
  setDescribedByIds(ids: string[]): void {
    this.matSelect.setDescribedByIds(ids)
  }
  // prettier-ignore-end
}
